



















































































import Vue from "vue";

import IconTerratalk from "@joyz/app-core/assets/logo/terratalk-icon-fullcolor.svg";
import IconClose from "@joyz/app-core/assets/icons/black/Close.svg";

import { FooterState } from "@tt-app/models/exercise";

interface Props {
  iconTerratalk: string;
  iconClose: string;
  footer: FooterState;
  displayExitConfirmation: boolean;
  limitedModeUpdated: boolean;
}

/**
 * @emits close-icon-click
 * @emits exit-confirmed
 * @emits exit-cancelled
 */
export default Vue.extend<any, any, any, Props>({
  name: "LayoutExercise",

  props: {
    iconTerratalk: { type: String, default: IconTerratalk },
    iconClose: { type: String, default: IconClose },
    footer: { type: Object as () => FooterState, required: true },
    displayExitConfirmation: { type: Boolean, default: false },
    limitedModeUpdated: { type: Boolean, default: false }
  },

  computed: {
    sessionExitText() {
      return this.$__("tt-live.exit.confirmation");
    }
  }
});
